import React, { useEffect } from 'react'
import styles from "./FormDetailsDrawer.styles"
import { HEADING } from '../../../../components/heading/constants/constants'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import DrawerWithTitleAndFooter from '../../../../components/drawer/DrawerWithTitleAndFooter'
import HorizontalProgressBar from '../../../../components/progressbar/HorizontalProgressBar'
import Heading from '../../../../components/heading/Heading'
import Button from '../../../../components/button/Button'
import IconDropdown from '../../../../components/dropdown/icondropdown/IconDropdown'
import Icons from '../../../../components/icons/Icons'
import HorizontalSeparator from '../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import DateUtils from '../../../../../libs/utility/DateUtils'
import Checkbox from '../../../../components/checkbox/basecheckbox/Checkbox'
import { FIELD_TYPES } from '../../../../../libs/formdatavalidator/constants'
import { setAssignFormsToReviewersModal, setHighlightedForm, setSubmitForRecipientPendingModal, setSubmitForThisPayerReviewedCheckboxModal, setSubmitForThisPayerWarningModal, setSubmittedForms } from '../FormListingSlice'
import { setStatePayrollSubmitForThisPayerModal, setAssignStatePayrollFormsToReviewersModal } from '../formslistingstatepayroll/FormStatePayrollSlice'
import { useDispatch, useSelector } from 'react-redux'
import { ShowForAllowedPermissionsOnly } from '../../../wrappers/ShowForAllowedPermissionsOnly'
import { PAGE_PERMISSIONS } from '../../../dashboard/constants/constant'
import { ShowForRejectedPermissionsOnly } from '../../../wrappers/ShowForRejectedPermissionsOnly'
import CheckboxWLabel from '../../../../components/checkbox/checkboxwlabel/CheckboxWLabel'
import { loadFormsData, submitForSinglePayer } from '../FormListingSaga'
import { PAGE_STATE } from '../../../constants/constants'
import { TxSpinner } from '../../../../components/spinner/TxSpinner'
import Loadable from '../../../../components/loadable/Loadable'
import { FORM_LISTING_LOADING_STATES, FORM_LISTING_MESSAGE_MAP, LOAD_FORMS_DATA_STATE, FORM_NAMS } from '../constants'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import { componentKey } from './FormDetailsDrawerSlice'
import { getFormDetails } from './FormDetailsDrawerSaga'
import General from '../../../../../libs/utility/General'
import { componentKey as formListingKey } from '../FormListingSlice'
import { TIN_STATUS } from '../../constants'
import { isAccessAllowed, useUserPermissionsInfo } from '../../../dashboard/hooks/userHooks'
import { setShowPaymentNotAllowedPopup } from '../../../dashboard/DashboardSlice'
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'

const FormDetailsDrawer = ({
    isOpen,
    title = "Form details",
    onCloseCb,
    actionDropdown = [],
    isReadyToSubmit = true,
    feeData = {},
    onSubmitCb = () => { },
    highlightedForm = {},
    submittedForms = [],
    selectedForm = { label: "", value: "" },
    selectedPayer = { label: "", value: "" },
    selectedTaxYear = { label: "", value: "" },
    drawerLoader = false,
    showUnverifiedTinMessage = false,
    loadingState = { state: "" },
    fillingType = {fillingType}
}) => {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const { permissions } = useUserPermissionsInfo();

    const { readyToSubmitTabCheckboxes, formType, selectedReadyToSubmitForms } = useSelector(state => state[formListingKey]);
    const { loadingState: formDetailsLoader, categorisedFormFields, formDetails, tinVerificationAmount } = useSelector(state => state[componentKey]);
    const { forms94xList } = useSelector(state => state[dataLoaderKey]);

    useEffect(() => {
        dispatch(getFormDetails({ formRecordId: highlightedForm.FormId, formName: selectedForm?.FormShortName, year: selectedTaxYear?.label }))
    }, [])

    const renderCategorisedFormFields = (obj = {}) => {
        return Object.keys(obj).map((key) => {
            const item = obj[key];
            let displayValue;

            switch (item.Type) {
                case FIELD_TYPES.CURRENCY:
                    displayValue = item.Value ? `$${item.Value}` : '-';
                    break;
                case FIELD_TYPES.BOOLEAN:
                case FIELD_TYPES.RADIO:
                    displayValue = <Checkbox checked={item.Value} disabled />
                    break;
                case FIELD_TYPES.STRING:
                case FIELD_TYPES.LABEL:
                case FIELD_TYPES.DATE:
                case FIELD_TYPES.ENUM:
                case FIELD_TYPES.TEXTAREA:
                    displayValue = item?.Value ? item?.Value : '-';
                    break;
                default:
                    displayValue = item.Value;
            }

            return (
                <div style={styles.box} key={key}>
                    <div style={styles.info}>
                        <span >{displayValue}</span>
                        <span style={styles.infoText}>{item?.Label}</span>
                    </div>
                </div>
            );
        });
    }

    const onChangeTINRequestCheckbox = (isChecked) => {
        const copy = JSON.parse(JSON.stringify(submittedForms));

        const updatedFormList = copy.map(form => {
            if (form?.FormId == highlightedForm?.FormId) {
                form.IsTinCheck = isChecked;
                dispatch(setHighlightedForm({ ...highlightedForm, IsTinCheck: isChecked }))
            }

            return form;
        });

        dispatch(setSubmittedForms(updatedFormList));
        dispatch(loadFormsData({ PayerId: selectedPayer?.value, selectedForm, TaxYear: selectedTaxYear?.value, filingType: fillingType?.value || false, submitType: LOAD_FORMS_DATA_STATE.CALCULATE_TAX_1099_FEE, formType, fromDrawer: true }))
    }

    const { DELETE_BULK_FORM_FROM_DRAWER_LOADING, DELETE_SINGLE_FORM_FROM_DRAWER_LOADING, GET_FORM_DETAILS_LOADING, SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_LOADING, DOWNLOAD_SINGLE_PDF_LOADING, CALCULATE_FEE_AMOUNT_LOADING, FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING } = FORM_LISTING_LOADING_STATES

    const FORM_DETAILS_DRAWER_LOADING_STATES = [SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_LOADING, DELETE_BULK_FORM_FROM_DRAWER_LOADING, DELETE_SINGLE_FORM_FROM_DRAWER_LOADING, CALCULATE_FEE_AMOUNT_LOADING, FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING];

    return (
        <DrawerWithTitleAndFooter
            isOpen={isOpen}
            onCloseCb={onCloseCb}
            title={title}
        >
            <Loadable
                currentState={formDetailsLoader.state}
                messageMap={FORM_LISTING_MESSAGE_MAP}
                loadingStates={[GET_FORM_DETAILS_LOADING]}
                isNewLoadable={true}
            >

                <Loadable
                    currentState={loadingState.state}
                    messageMap={FORM_LISTING_MESSAGE_MAP}
                    loadingStates={FORM_DETAILS_DRAWER_LOADING_STATES}
                    isNewLoadable={true}
                >
                    <span style={styles.infoText}>#{formDetails.FormRecordId} | Last Updated - {DateUtils.dateFormatter(formDetails.updated_date, "DD-MM-YYYY")}</span>

                    {isReadyToSubmit ?
                        (
                            <div style={styles.actionBox}>
                                <Icons familyName='vec' iconName={VEC_ICON_NAME.READY_TO_SUBMIT} />

                                <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS}>
                                    <Heading type={HEADING.H3} customStyle={styles.count}>Ready to Submit</Heading>
                                    <span style={styles.infoText}> You are just a few seconds away from submitting the form to the IRS.</span>
                                </ShowForAllowedPermissionsOnly>

                                <ShowForRejectedPermissionsOnly toCheck={PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS}>
                                    <Heading type={HEADING.H3} customStyle={styles.count}>Ready to assign</Heading>
                                    <span style={styles.infoText}> You are just a few seconds away from assigning a forms to reviewer.</span>
                                </ShowForRejectedPermissionsOnly>

                                <div style={styles.buttonContainer}>
                                    <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS}>
                                        <Button
                                            style={{ width: "240px" }}
                                            type={BUTTON_TYPE.PRIMARY}
                                            disabled={General.disablePaymentFeature(selectedTaxYear?.value, selectedForm?.FormShortName)}
                                            onClickCb={() => {
                                                if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                                                    if (highlightedForm?.IsUSPSMail || highlightedForm?.IsEmailRecipient) {
                                                        onSubmitCb();
                                                    } else if (highlightedForm?.TinStatus === TIN_STATUS.PROCESSING) {
                                                        dispatch(setSubmitForRecipientPendingModal(true))
                                                    }
                                                    else {
                                                        if(General.is94xForm(forms94xList, selectedForm?.FormName1)){
                                                            dispatch(setSubmitForThisPayerReviewedCheckboxModal(true))
                                                        }else if(selectedForm.FormName1.includes(FORM_NAMS.STATEPAYROLL)){
                                                            dispatch(setStatePayrollSubmitForThisPayerModal(true))
                                                        }else{
                                                            dispatch(setSubmitForThisPayerWarningModal(true))
                                                        }
                                                    }                                                        
                                                } else {
                                                    dispatch(setShowPaymentNotAllowedPopup(true))
                                                }
                                            }}
                                        >
                                            Submit Form Now - ${feeData?.TotalFilingFee ? General.getDecimalAmount(feeData?.TotalFilingFee) : 0}
                                        </Button>
                                    </ShowForAllowedPermissionsOnly>

                                    <ShowForRejectedPermissionsOnly toCheck={PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS}>
                                        <Button
                                            style={{ width: "240px" }}
                                            type={BUTTON_TYPE.PRIMARY}
                                            onClickCb={() => {!selectedForm.FormName1.includes(FORM_NAMS.STATEPAYROLL) ? dispatch(setAssignFormsToReviewersModal(true)) : dispatch(setAssignStatePayrollFormsToReviewersModal(true))}}
                                        >
                                            Submit for review
                                        </Button>
                                    </ShowForRejectedPermissionsOnly>

                                    <Loadable
                                        currentState={loadingState.state}
                                        loadingStates={[DOWNLOAD_SINGLE_PDF_LOADING]} isNewLoadable={true}
                                        messageMap={FORM_LISTING_MESSAGE_MAP}
                                        isFullWidth={false}
                                    >
                                        <IconDropdown
                                            label="Action"
                                            dropdownItems={actionDropdown}
                                            dropdownContainerStyles={styles.actionDropdown}
                                            styles={styles.actionDropdownLabel}
                                            dropdownMenuStyle={styles.actionDropdownMenu}
                                        />
                                    </Loadable>
                                </div>

                                {/* Rejected Blocked */}
                                {<ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.SUBMIT_TO_FORMS_PAGE_FORMS}>
                                    {(formDetails?.TINStatus === TIN_STATUS.NOT_SUBMITTED || formDetails?.TINStatus === TIN_STATUS.REJECTED || formDetails?.TINStatus === TIN_STATUS.BLOCKED) && highlightedForm?.TinStatus !== TIN_STATUS.PROCESSING &&
                                        (
                                            <>
                                                <HorizontalSeparator style={styles.horizontalLine} />

                                                <div style={styles.alert}>
                                                    <Icons familyName='vec' iconName={VEC_ICON_NAME.ALERT_ICON_SM} />
                                                    {<span>
                                                        Unverified recipient! Verify now to avoid wrong filing to IRS. Verify TIN with IRS <b>$ {tinVerificationAmount}</b>
                                                    </span>}
                                                </div>
                                                <CheckboxWLabel
                                                    label='Verify TIN'
                                                    checked={highlightedForm?.IsTinCheck}
                                                    labelCustomStyles={{ marginLeft: "8px" }}
                                                    onChangeCb={(e) => onChangeTINRequestCheckbox(e.target.checked)}
                                                />
                                            </>
                                        )
                                    }
                                </ShowForAllowedPermissionsOnly>}

                            </div>
                        ) :
                        (
                            <div style={styles.actionBox}>
                                <HorizontalProgressBar value={70} maxValue={100} label="Progress: 70%" />
                                <Heading type={HEADING.H3} customStyle={styles.count}>40% completed!</Heading>
                                <span style={styles.infoText}>Complete the form now and submit it to the IRS to avoid late eFilings.</span>

                                <div style={styles.buttonContainer}>
                                    <Button
                                        style={{ width: "180px" }}
                                        type={BUTTON_TYPE.PRIMARY}
                                        onClickCb={() => { }}
                                    >
                                        Continue eFiling
                                    </Button>

                                    <IconDropdown
                                        label="Action"
                                        dropdownItems={actionDropdown}
                                        dropdownContainerStyles={styles.actionDropdown}
                                        styles={styles.actionDropdownLabel}
                                        dropdownMenuStyle={styles.actionDropdownMenu}
                                    />
                                </div>
                            </div>
                        )
                    }


                    <div style={styles.informationBox}>
                        <Heading type={HEADING.H2} customStyle={styles.count}>Payers & Recipients Information</Heading>
                        <div style={styles.information}>
                            <div style={styles.payerInfo}>
                                <Icons familyName='vec' iconName={VEC_ICON_NAME.PAYER_ICON_2} />
                                <div>
                                    <Heading type={HEADING.H3}>{formDetails.PayerFirstName} {formDetails.PayerLastName}</Heading>
                                    <p style={styles.infoText}>Payers</p>
                                </div>
                            </div>
                            <div style={styles.payerInfo}>
                                <Icons familyName='vec' iconName={VEC_ICON_NAME.RECIPIENT_ICON_2} />
                                <div>
                                    <Heading type={HEADING.H3}>{formDetails.PayeeFirstName} {formDetails.PayeeLastName}</Heading>
                                    <p style={styles.infoText}>Recipients</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {!selectedForm.FormName1.includes(FORM_NAMS.STATEPAYROLL) && (
                        <div>
                            <Heading type={HEADING.H2} customStyle={styles.count}>
                                Federal Information.
                            </Heading>
                            <div style={styles.flexboxContainer}>
                                {categorisedFormFields?.FEDERAL &&
                                    Object.entries(categorisedFormFields?.FEDERAL)?.length ? (
                                    renderCategorisedFormFields(categorisedFormFields.FEDERAL)
                                ) : (
                                    <div style={styles.info}>
                                        <span>N/A</span>
                                    </div>
                                )}
                            </div>

                            <div style={styles.informationBox}>
                                <Heading type={HEADING.H2} customStyle={styles.count}>
                                    State Information.
                                </Heading>
                                <div style={styles.flexboxContainer}>
                                    {categorisedFormFields?.STATE &&
                                        Object.entries(categorisedFormFields?.STATE)?.length ? (
                                        renderCategorisedFormFields(categorisedFormFields.STATE)
                                    ) : (
                                        <div style={styles.info}>
                                            <span>N/A</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div>
                                <Heading type={HEADING.H2}>Account No</Heading>
                                <span>{formDetails?.AccountNumber || "N/A"}</span>
                            </div>
                        </div>
                    )}

                    {selectedForm.FormName1.includes(FORM_NAMS.STATEPAYROLL) && (
                        <div style={styles.informationBox}>
                            <Heading type={HEADING.H2} customStyle={styles.count}>State Payroll Information</Heading>
                            <div style={styles.flexboxContainer}>
                                {categorisedFormFields?.STATEPAYROLL &&
                                    Object.entries(categorisedFormFields?.STATEPAYROLL)?.length
                                    ?
                                    renderCategorisedFormFields(categorisedFormFields?.STATEPAYROLL)
                                    :
                                    <div style={styles.info}>
                                        <span>N/A</span>
                                    </div>
                                }
                            </div>
                        </div>
                    )}                       
                    
                </Loadable>

            </Loadable>

        </DrawerWithTitleAndFooter >
    )
}

export default FormDetailsDrawer
